import * as React from "react";

const GSCaseInformation = ({
  caseId,
  location,
  openDate,
  agency,
  circumstances,
  contactInformation
}) => {
  return (
    <div>
      <h2>Case Information:</h2>
      <div className="geosearch-result__case-info">
        <div className="geosearch-result__case-id">
          <h5>Case Id:</h5>
          <p>{caseId}</p>
        </div>
        <div className="geosearch-result__case-location">
          <h5>Case Location:</h5>
          <p>{location}</p>
        </div>
        <div className="geosearch-result__circumstances">
          <h5>Missing Circumstances:</h5>
          <p>{circumstances}</p>
        </div>
        <div className="geosearch-result__open-date">
          <h5>Open Date:</h5>
          <p>{openDate}</p>
        </div>
        <div className="geosearch-result__agency">
          <h5>Agency:</h5>
          <p>{agency}</p>
        </div>
        <div className="geosearch-result__contact-info">
          <h5>Contact Information:</h5>
          <p>{contactInformation}</p>
        </div>
      </div>
    </div>
  );
};

export default GSCaseInformation;
